import Loader from "components/Loader";
import { useModal } from "context/hooks/useModal";

const RenderTermsAndPrivacy = ({ url }) => {
  const { hideModal } = useModal();
  return (
    <div className="max-h-[90vh] md:max-h-[70vh] overflow-y-auto">
      <button
        className="rounded-full border border-black w-6 h-6"
        onClick={hideModal}
      >
        X
      </button>
      <div className="w-full" id="iframe-loader">
        <Loader open type="block" position="portal" />
      </div>

      <iframe
        src={url}
        className="w-full h-[calc(70vh-30px)]"
        onLoad={() => {
          const loaderEle = document.getElementById("iframe-loader");
          loaderEle.style.display = "none";
        }}
      />
    </div>
  );
};

export default RenderTermsAndPrivacy;
